import type { ReactNode } from "react";
import { COLORS } from "../../lib/brand";
import { Text, View } from "react-native";

export function Section({
  overline,
  title,
  subtitle,
  action,
  theme = "light",
  children,
}: {
  overline?: string;
  title?: string;
  subtitle?: string;
  action?: ReactNode;
  /** Dark theme uses linen text on forest/black backgrounds; light uses forest text on sand. */
  theme?: "light" | "dark";
  children: ReactNode;
}) {
  const hasHeaderRow = Boolean(title || action);
  const titleColor = theme === "dark" ? COLORS.LINEN.hex : COLORS.FOREST.hex;
  const subtitleClass =
    theme === "dark"
      ? "text-[13px] leading-6 text-white/65"
      : "text-[13px] leading-6 text-text/65";
  return (
    <View>
      {overline ? (
        <Text
          className="text-[10px] font-bold uppercase tracking-[0.2em] text-amber"
          style={{ fontFamily: "DMSans_700Bold", letterSpacing: 2 }}
        >
          {overline}
        </Text>
      ) : null}
      {hasHeaderRow ? (
        <View className={`flex-row items-start justify-between gap-3 ${overline ? "mt-1" : ""}`}>
          <View className="min-w-0 flex-1">
            {title ? (
              <Text
                style={{
                  fontSize: 31,
                  lineHeight: 34,
                  fontFamily: "CormorantGaramond_400Regular",
                  color: titleColor,
                }}
              >
                {title}
              </Text>
            ) : null}
            {subtitle ? (
              <Text
                className={`${subtitleClass} ${title ? "mt-2" : ""}`}
                style={{ fontFamily: "DMSans_400Regular" }}
              >
                {subtitle}
              </Text>
            ) : null}
          </View>
          {action ? <View className="shrink-0 pt-1">{action}</View> : null}
        </View>
      ) : subtitle ? (
        <Text
          className={`${subtitleClass} ${overline ? "mt-1" : "mt-2"}`}
          style={{ fontFamily: "DMSans_400Regular" }}
        >
          {subtitle}
        </Text>
      ) : null}
      <View className="mt-6">{children}</View>
    </View>
  );
}
